var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 19.6C28 20.3426 27.705 21.0548 27.1799 21.5799C26.6548 22.105 25.9426 22.4 25.2 22.4H8.4C6.846 22.4 5.6 21.14 5.6 19.6V2.8C5.6 1.246 6.846 0 8.4 0H25.2C25.9426 0 26.6548 0.294999 27.1799 0.820101C27.705 1.3452 28 2.05739 28 2.8V19.6ZM19.6 25.2V28H2.8C2.05739 28 1.3452 27.705 0.820101 27.1799C0.294999 26.6548 0 25.9426 0 25.2V7H2.8V25.2H19.6ZM15.4 16.8L25.2 7L23.226 5.026L15.4 12.838L11.074 8.526L9.1 10.5L15.4 16.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.029df7d2345bf33af5ff5b05e2348580.svg";
export { ForwardRef as ReactComponent };